import axios from "axios";
import moment from "moment-jalaali";

// export const baseURL = 'http://127.0.0.1:4000'
export const baseURL = "https://cafefollow.codechi-group.ir"

function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const restful = axios.create({ baseURL });

restful.interceptors.request.use(async (config) => {

    const expires_at = localStorage.getItem("expires_at")
    if (expires_at && moment(expires_at).subtract(10, 'seconds').isBefore()) {
        const refresh_token = localStorage.getItem("refresh_token")
        if (refresh_token) {
            localStorage.clear()
            try {
                const res = await axios.post(baseURL + "/tokens/refresh",
                    { refresh_token }, { headers: { "x-client": "admin" } })
                localStorage.setItem('access_token', res.data.result.access_token)
                localStorage.setItem('refresh_token', res.data.result.refresh_token)
                localStorage.setItem('expires_at', res.data.result.expires_at)
            } catch (error) {
                window.location.href = '/login'
            }
        }
    }

    if (config.headers) {
        const access_token = localStorage.getItem("access_token")
        if (!access_token) await sleep(2000)
        config.headers.Authorization = `Bearer ${localStorage.getItem("access_token")}`;
        config.headers["x-client"] = "admin"
    }

    return config;
});

restful.interceptors.response.use(res => res, err => {
    if (err.response.status === 401)
        window.location.href = '/login'
    throw err
})

export default restful;
